export default "__VITE_PUBLIC_ASSET__ee6067f7__"